export default "assets/images/icons/weibo-7e7081dd.svg";